import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  searchIcon: {
    width: 20,
    height: 20,
  },
}))

export default useStyles
